export default "__VITE_ASSET__Iu9xBV_Q__"